import { View, StyleSheet, Image, Text } from "@react-pdf/renderer";
import React from "react";
import PdfLogo from "../../assets/images/service-aggrement-pdf-logo.jpeg";
import PdfLogoSub from "../../assets/images/service-aggrement-pdf-eit.jpeg";

const styles = StyleSheet.create({
  headerBarSecondary: {
    position: "absolute",
    height: "100%",
    width: "160px",
    backgroundColor: "#f1f1f1",
  },
  logoContainer: {
    alignItems: "flex-end",
    marginBottom: 10,
  },
  pdfLogo: {
    width: "155px",
  },
  pdfLogoSub: {
    width: "45px",
    // marginTop: 5,
  },
  pdfLogoSubText: {
    fontSize: 16,
  },
  pdfLogoSubText2: {
    fontSize: 10,
    marginBottom: 6,
  },
  logoSubContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  pdfLogoSubTextContainer: {
    gap: 3,
  },
  children: {
    paddingHorizontal: 25,
  },
});

const Header = ({ children }) => {
  return (
    <View>
      {/* Logo Container */}
      <View style={styles.logoContainer} fixed>
        <Image src={PdfLogo} style={styles.pdfLogo} />
      </View>

      {/* Logo Sub Container */}
      <View style={styles.logoSubContainer} fixed>
        {/* Logo Sub Text Container */}
        <View style={styles.pdfLogoSubTextContainer}>
          <Text style={styles.pdfLogoSubText}>
            POS Terminal Hire and Services Contract
          </Text>
          <Text style={styles.pdfLogoSubText}>
            Services Agreement (Card Payment Terminals)
          </Text>
          <Text style={styles.pdfLogoSubText2}>
            The services and devices are provided by:
          </Text>
        </View>

        {/* Logo Sub Image */}
        <Image src={PdfLogoSub} style={styles.pdfLogoSub} />
      </View>
      <View style={styles.children}>{children}</View>
    </View>
  );
};

export default Header;
